/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { useAuth } from "@/Providers/Auth";
import { useStaticData } from "@/Providers/Data";
import { useGeneralSettings } from "@/Providers/General";
import { useInfluencer } from "@/Providers/Influencer";
import { useToast } from "@/shadcnComponents/ui/use-toast";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  audienceDataProps,
  chargesDataProps,
  collabDataProps,
  contentDataProps,
  monetizationDataProps,
  profileDataProps,
  verificationDataProps,
} from "./UserInfoProps";
import mixpanel from "mixpanel-browser";
import { dataUriToFile, generateRandomName } from "./UserInfoHelpers";
import { useExtension } from "@/Providers/Extension";

export const useUserInfoHooks = () => {
  const navigate = useNavigate();
  const [currentPage, setCurrentPage] = useState("profile");
  const [isManually, setIsManually] = useState(false);
  const [currentSection, setCurrentSection] = useState("preExtension");
  const [, setErrorArray] = useState([]);
  const dataState = useStaticData();
  const { toast } = useToast();
  const [fade, setFade] = useState(false);

  const authState = useAuth();
  const influencerState = useInfluencer();
  const generalState = useGeneralSettings();
  const extensionState = useExtension();
  const [chipsData, setChipsData] = useState({});
  const [, setTotalChipsCount] = useState(0);
  const [referCode, setReferCode] = useState(null);

  const [profileFormImages, setProfileFormImages] = useState<[]>([]);
  const [profileData, setProfileData] = useState<profileDataProps>({
    name: "",
    tagline: "",
    linkedinLink: "",
    gender: "",
    twitterLink: "",
    instaLink: "",
    linkTreeLink: "",
    whatsappLink: "",
    YouTubeLink: "",
    fbLink: "",
    telegramLink: "",
    coverPhoto: "",
    profile: "",
    websiteLink: "",
    followers: {
      linkedin: null,
      twitter: null,
      fb: null,
      telegram: null,
      insta: null,
      website: null,
      linktree: null,
      whatsapp: null,
      youTube: null,
    },
    location: {
      country: "India",
      state: "",
      city: "",
    },
    dob: "",
  });
  const [contentData, setContentData] = useState<contentDataProps>({
    categories: [],
    formats: [],
  });
  const [audienceData, setAudienceData] = useState<audienceDataProps>({
    types: [],
    platforms: [
      {
        platform: "",
        audience: null,
        link: "",
      },
    ],
  });
  const [chargesData, setChargesData] = useState<chargesDataProps>({
    PostMaxPrice: null,
    PostMinPrice: null,
    MonthlyNumberOfPost: null,
    MonthlyMaxPrice: null,
    MonthlyMinPrice: null,
    YearlyNumberOfPost: null,
    YearlyMaxPrice: null,
    YearlyMinPrice: null,
    AcceptFreeBies: true,
    isNegotiable: false,
  });
  const [collabData, setCollabData] = useState<[collabDataProps]>([
    {
      companyName: "",
      companyUrl: "",
      companyProfile: "",
      postLink: "",
      goals: [],
    },
  ]);
  const [monetizationData, setMonetizationData] = useState<
    [monetizationDataProps]
  >([
    {
      platformName: "",
      profileLink: "",
      paidAudience: null,
      methods: [],
    },
  ]);
  const [verificationData, setVerficationData] =
    useState<verificationDataProps>({
      email: "",
      mobile: "",
    });
  const [MediaKitsheetsData, setMediaKitSheetsData] = useState<{
    DEMOGRAPHICS: any[];
    DISCOVERY: any[];
    ENGAGEMENT: any[];
    FOLLOWERS: any[];
    TOPPOSTS: any[];
  }>({
    DEMOGRAPHICS: [],
    DISCOVERY: [],
    ENGAGEMENT: [],
    FOLLOWERS: [],
    TOPPOSTS: [],
  });

  useEffect(() => {
    mixpanel.track("Page visited Anchors Collab");

    if (authState?.loggedUser?.refered_by) {
      // If user already has a referral in their profile, use that
      setReferCode(authState?.loggedUser?.refered_by);
    } else {
      // Check localStorage
      const storedReferralJSON = localStorage.getItem("anchors_collab_refer");

      // Handle both new JSON format and legacy string format
      if (storedReferralJSON) {
        try {
          // Try to parse as JSON (new format)
          const storedReferral = JSON.parse(storedReferralJSON);

          // Check if 24 hours have passed
          const now = Date.now();
          const hoursPassed =
            (now - storedReferral.timestamp) / (1000 * 60 * 60);

          if (hoursPassed < 24) {
            // Referral code is still valid
            setReferCode(storedReferral.code);
          } else {
            // Expired referral, clear it
            localStorage.removeItem("anchors_collab_refer");
            setReferCode(null);
          }
        } catch (e) {
          // This handles the case of old format (just the code without timestamp)
          // For backwards compatibility, we'll consider these as not expired
          localStorage.removeItem("anchors_collab_refer");
          setReferCode(storedReferralJSON);
        }
      } else {
        setReferCode(null);
      }
    }
  }, [authState]);
  useEffect(() => {
    if (authState?.loggedUser?.is_verified) {
      navigate("/dashboard");
    }
  }, [authState?.loggedUser]);
  useEffect(() => {
    setErrorArray([]);
    generalState.setLoading(true);
    influencerState?.getPersonalInfo().then((e) => {
      generalState.setLoading(false);
      if (e?.success) {
        setProfileData({ ...profileData, ...e?.data });

        if (e?.data2?.data?.length) {
          setCollabData(
            e?.data2?.data ?? [
              {
                companyName: "",
                companyUrl: "",
                companyProfile: "",
                postLink: "",
                goals: [],
              },
            ]
          );
        } else {
          setCollabData([
            {
              companyName: "",
              companyUrl: "",
              companyProfile: "",
              postLink: "",
              goals: [],
            },
          ]);
        }

        if (e?.data3?.data.length) {
          setMonetizationData(
            e?.data3?.data ?? [
              {
                platformName: "",
                profileLink: "",
                paidAudience: null,
                methods: [],
              },
            ]
          );
        } else {
          setMonetizationData([
            {
              platformName: "",
              profileLink: "",
              paidAudience: null,
              methods: [],
            },
          ]);
        }

        setContentData(
          e.data4 ?? {
            categories: [],
            formats: [],
          }
        );

        if (e?.data5?.platforms?.length) {
          setAudienceData(
            e.data5 ?? {
              ...audienceData,
              platforms: [
                {
                  platform: "",
                  audience: null,
                  link: "",
                },
              ],
            }
          );
        } else {
          setAudienceData({
            ...audienceData,
            platforms: [
              {
                platform: "",
                audience: null,
                link: "",
              },
            ],
          });
        }

        setChargesData(
          e.data6 ?? {
            PostMaxPrice: null,
            PostMinPrice: null,
            MonthlyNumberOfPost: null,
            MonthlyMaxPrice: null,
            MonthlyMinPrice: null,
            YearlyNumberOfPost: null,
            YearlyMaxPrice: null,
            YearlyMinPrice: null,
            AcceptFreeBies: true,
            isNegotiable: false,
          }
        );
      }
    });
  }, [currentPage]);
  useEffect(() => {
    dataState.getDataFromType("Influencer Chips").then((e) => {
      setChipsData(e[0]);
    });
  }, []);
  useEffect(() => {
    setErrorArray([]);
    const cfd1 = CountTheChips(profileData, "personal");
    const cfd2 = CountTheChips(collabData, "collab");
    const cfd3 = CountTheChips(monetizationData, "monetisation");
    const cfd4 = CountTheChips(contentData, "content");
    const cfd5 = CountTheChips(audienceData, "audience");
    const cfd6 = CountTheChips(audienceData, "charges");
    const cdf7 =
      authState?.loggedUser?.referralCount * parseInt(chipsData?.["referral"]);

    generalState?.setSidebarChipsCount({
      profile: cfd1,
      collab: cfd2,
      monetization: cfd3,
      content: cfd4,
      audience: cfd5,
      charges: cfd6,
      referral: cdf7,
    });
  }, [
    profileData,
    contentData,
    audienceData,
    monetizationData,
    collabData,
    chargesData,
  ]);
  useEffect(() => {
    setTotalChipsCount(
      generalState.SidebarChipsCount.profile +
        generalState.SidebarChipsCount.content +
        generalState.SidebarChipsCount.audience +
        generalState.SidebarChipsCount.collab +
        generalState.SidebarChipsCount.monetization +
        generalState.SidebarChipsCount.charges +
        generalState.SidebarChipsCount.referral
    );
  }, [
    profileData,
    contentData,
    audienceData,
    monetizationData,
    collabData,
    chargesData,
  ]);
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    if (params.get("preview-data") === "true") {
      setCurrentPage("preview-data");
    }
  }, [window.location.search]);
  useEffect(() => {
    if (authState?.loggedUser?.selectedWhatYouWillFind) {
      setCurrentSection("extension");
    }
  }, []);

  const handleSubmit = async () => {
    // generalState?.setLoading(true);
    setFade(true);
    setTimeout(() => {
      setFade(false);
    }, 300);
    if (currentPage === "profile") {
      await handleSubmitProfileForm();
      generalState?.setLoading(false);
    } else if (currentPage === "mediaKit") {
      await handeSubmitManualMediaKit();
      generalState?.setLoading(false);
    } else if (currentPage === "content") {
      await handleSubmitContentForm();
      setCurrentPage("verification");

      generalState?.setLoading(false);
    } else if (currentPage === "audience") {
      setCurrentPage("verification");
      // await handleSubmitAudienceForm();
      generalState?.setLoading(false);
    }
  };
  const handleSubmitProfileForm = async () => {
    try {
      if (profileData?.name?.length < 1) {
        setErrorArray((prev) => {
          const newArr = [...prev, "name"];
          return newArr;
        });
        toast({
          variant: "destructive",
          title: "There was a problem with your request.",
          description: "Please Enter proper Name",
        });
        return;
      } else if (profileData?.tagline?.length < 1) {
        setErrorArray((prev) => {
          const newArr = [...prev, "tagline"];
          return newArr;
        });
        toast({
          variant: "destructive",
          title: "There was a problem with your request.",
          description: "Please Enter Your Tagline",
        });
        return;
      } else if (!profileData?.gender || profileData?.gender === "") {
        setErrorArray((prev) => {
          const newArr = [...prev, "gender"];
          return newArr;
        });
        toast({
          variant: "destructive",
          title: "There was a problem with your request.",
          description: "Please Select Gender",
        });
        return;
      } else if (!profileData?.dob) {
        setErrorArray((prev) => {
          const newArr = [...prev, "dob"];
          return newArr;
        });
        toast({
          variant: "destructive",
          title: "There was a problem with your request.",
          description: "Please Select Date of Birth",
        });
        return;
      } else {
        // const instaLinkRegex =
        //   /^(https?:\/\/)?(www\.)?instagram\.com\/[a-zA-Z0-9_]+\/?$/;
        // const linkedinLinkRegex =
        //   /^(https?:\/\/)?(www\.)?linkedin\.com\/in\/[a-zA-Z0-9_-]+\/?$/;
        // const twitterLinkRegex =
        //   /^(https?:\/\/)?(www\.)?twitter\.com\/[a-zA-Z0-9_]+\/?$/;
        // const telegramLinkRegex =
        //   /^(https?:\/\/)?(|www)[.]?((t|telegram)\.me)\/[a-zA-Z0-9_]{5,32}$/;
        // const fbLinkRegex =
        //   /^(https?:\/\/)?(www\.)?facebook\.com\/[a-zA-Z0-9_-]+\/?$/;
        // const whatsappLinkRegex =
        //   /(?:https?:\/\/)?(?:www\.)?(?:chat\.whatsapp\.com|invite\.whatsapp\.com)\/?(?:[a-zA-Z0-9]+)?(?:\?|&)?(invite=)?([a-zA-Z0-9]+)/g;
        // const youTubeLinkRegex =
        //   /(?:https?:\/\/)?(?:www\.)?(?:youtube\.com\/(?:channel\/|user\/|c\/)?|youtu\.be\/|youtube\.com\/@)([a-zA-Z0-9_-]{24}|[a-zA-Z0-9_-]+)/;
        // const linkTreeLinkRegex =
        //   /(?:https?:\/\/)?(?:www\.)?linktr\.ee\/([a-zA-Z0-9_]+)/;

        // if (
        //   profileData?.instaLink &&
        //   !instaLinkRegex.test(profileData?.instaLink)
        // ) {
        //   return toast({
        //     variant: "destructive",
        //     title: "There was a problem with your request.",
        //     description: "Please Enter proper Instagram Link",
        //   });
        // } else if (profileData?.instaLink && !profileData?.followers?.insta) {
        //   return toast({
        //     variant: "destructive",
        //     title: "There was a problem with your request.",
        //     description: "Please Enter Instagram followers",
        //   });
        // } else if (profileData?.followers?.insta && !profileData?.instaLink) {
        //   return toast({
        //     variant: "destructive",
        //     title: "There was a problem with your request.",
        //     description: "Please Enter Instagram Link",
        //   });
        // }
        // if (
        //   profileData?.linkedinLink &&
        //   !linkedinLinkRegex.test(profileData?.linkedinLink)
        // ) {
        //   return toast({
        //     variant: "destructive",
        //     title: "There was a problem with your request.",
        //     description: "Please Enter proper Linkedin Link",
        //   });
        // }
        // else if (
        //   profileData?.linkedinLink &&
        //   !profileData?.followers?.linkedin
        // ) {
        //   return toast({
        //     variant: "destructive",
        //     title: "There was a problem with your request.",
        //     description: "Please Enter Linkedin followers",
        //   });
        // }
        // else if (
        //   profileData?.followers?.linkedin &&
        //   !profileData?.linkedinLink
        // ) {
        //   return toast({
        //     variant: "destructive",
        //     title: "There was a problem with your request.",
        //     description: "Please Enter linkedin Link",
        //   });
        // }
        // if (
        //   profileData?.telegramLink &&
        //   !telegramLinkRegex.test(profileData?.telegramLink)
        // ) {
        //   return toast({
        //     variant: "destructive",
        //     title: "There was a problem with your request.",
        //     description: "Please Enter proper Telegram Link",
        //   });
        // } else if (
        //   profileData?.telegramLink &&
        //   !profileData?.followers?.telegram
        // ) {
        //   return toast({
        //     variant: "destructive",
        //     title: "There was a problem with your request.",
        //     description: "Please Enter Telegram followers",
        //   });
        // } else if (
        //   profileData?.followers?.telegram &&
        //   !profileData?.telegramLink
        // ) {
        //   return toast({
        //     variant: "destructive",
        //     title: "There was a problem with your request.",
        //     description: "Please Enter Telegram Link",
        //   });
        // }
        // if (
        //   profileData?.twitterLink &&
        //   !twitterLinkRegex.test(profileData?.twitterLink)
        // ) {
        //   return toast({
        //     variant: "destructive",
        //     title: "There was a problem with your request.",
        //     description: "Please Enter proper Twitter Link",
        //   });
        // } else if (
        //   profileData?.twitterLink &&
        //   !profileData?.followers?.twitter
        // ) {
        //   return toast({
        //     variant: "destructive",
        //     title: "There was a problem with your request.",
        //     description: "Please Enter Twitter followers",
        //   });
        // } else if (
        //   profileData?.followers?.twitter &&
        //   !profileData?.twitterLink
        // ) {
        //   return toast({
        //     variant: "destructive",
        //     title: "There was a problem with your request.",
        //     description: "Please Enter Twitter Link",
        //   });
        // }
        // if (profileData?.fbLink && !fbLinkRegex.test(profileData?.fbLink)) {
        //   return toast({
        //     variant: "destructive",
        //     title: "There was a problem with your request.",
        //     description: "Please Enter proper Facebook Link",
        //   });
        // } else if (profileData?.fbLink && !profileData?.followers?.fb) {
        //   return toast({
        //     variant: "destructive",
        //     title: "There was a problem with your request.",
        //     description: "Please Enter Facebook followers",
        //   });
        // } else if (profileData?.followers?.fb && !profileData?.fbLink) {
        //   return toast({
        //     variant: "destructive",
        //     title: "There was a problem with your request.",
        //     description: "Please Enter Facebook Link",
        //   });
        // }
        // if (profileData?.websiteLink && !profileData?.followers?.website) {
        //   return toast({
        //     variant: "destructive",
        //     title: "There was a problem with your request.",
        //     description: "Please Enter Website followers",
        //   });
        // } else if (
        //   profileData?.followers?.website &&
        //   !profileData?.websiteLink
        // ) {
        //   return toast({
        //     variant: "destructive",
        //     title: "There was a problem with your request.",
        //     description: "Please Enter Website Link",
        //   });
        // }

        // if (
        //   profileData?.whatsappLink &&
        //   !whatsappLinkRegex.test(profileData?.whatsappLink)
        // ) {
        //   return toast({
        //     variant: "destructive",
        //     title: "There was a problem with your request.",
        //     description: "Please Enter proper WhatsApp Link",
        //   });
        // } else if (
        //   profileData?.whatsappLink &&
        //   !profileData?.followers?.whatsapp
        // ) {
        //   return toast({
        //     variant: "destructive",
        //     title: "There was a problem with your request.",
        //     description: "Please Enter WhatsApp followers",
        //   });
        // } else if (
        //   profileData?.followers?.whatsapp &&
        //   !profileData?.whatsappLink
        // ) {
        //   return toast({
        //     variant: "destructive",
        //     title: "There was a problem with your request.",
        //     description: "Please Enter WhatsApp Link",
        //   });
        // }

        // if (
        //   profileData?.YouTubeLink &&
        //   !youTubeLinkRegex.test(profileData?.YouTubeLink)
        // ) {
        //   return toast({
        //     variant: "destructive",
        //     title: "There was a problem with your request.",
        //     description: "Please Enter proper YouTube Link",
        //   });
        // } else if (
        //   profileData?.YouTubeLink &&
        //   !profileData?.followers?.youTube
        // ) {
        //   return toast({
        //     variant: "destructive",
        //     title: "There was a problem with your request.",
        //     description: "Please Enter YouTube followers",
        //   });
        // } else if (
        //   profileData?.followers?.youTube &&
        //   !profileData?.YouTubeLink
        // ) {
        //   return toast({
        //     variant: "destructive",
        //     title: "There was a problem with your request.",
        //     description: "Please Enter YouTube Link",
        //   });
        // }

        // if (
        //   profileData?.linkTreeLink &&
        //   !linkTreeLinkRegex.test(profileData?.linkTreeLink)
        // ) {
        //   return toast({
        //     variant: "destructive",
        //     title: "There was a problem with your request.",
        //     description: "Please Enter proper linktree Link",
        //   });
        // } else if (
        //   profileData?.linkTreeLink &&
        //   !profileData?.followers?.linktree
        // ) {
        //   return toast({
        //     variant: "destructive",
        //     title: "There was a problem with your request.",
        //     description: "Please Enter linktree followers",
        //   });
        // } else if (
        //   profileData?.followers?.linktree &&
        //   !profileData?.linkTreeLink
        // ) {
        //   return toast({
        //     variant: "destructive",
        //     title: "There was a problem with your request.",
        //     description: "Please Enter linktree Link",
        //   });
        // }

        let coverPhoto = profileData.coverPhoto;
        let profile = profileData.profile;
        if (profileFormImages.length > 0) {
          for (let index = 0; index < profileFormImages.length; index++) {
            const element = profileFormImages[index];
            if (element) {
              const data1 = new FormData();
              const randomName = generateRandomName();
              const file = dataUriToFile(element, randomName + ".png");
              data1.append("file", file);
              const result = await influencerState?.uploadInfluencerImages(
                data1
              );
              if (result?.success) {
                if (index === 0) {
                  coverPhoto = result?.result?.Location;
                } else {
                  profile = result?.result?.Location;
                }
              }
            }
          }
        }
        if (referCode?.length) {
          const savereferralcode = await influencerState?.SaveUserInfo({
            refered_code: referCode,
          });
          if (!savereferralcode?.success) {
            return toast({
              variant: "destructive",
              title: "There was a problem with your request.",
              description: "Inavlid Referral code",
            });
          }
        }
        const response = await influencerState?.updatePersonalInfo({
          ...profileData,
          coverPhoto,
          profile,
        });
        if (response?.success) {
          setCurrentPage("mediaKit");
          // navigate("/influencer/build_profile?page=2");
        }
      }
    } catch (error) {
      return toast({
        variant: "destructive",
        title: "There was a problem with your request.",
        description: "Please Retry!",
      });
    }
  };
  const handeSubmitManualMediaKit = async () => {
    try {
      generalState?.setLoading(true);
      const response = await extensionState?.CreateManualMediaKit(
        MediaKitsheetsData
      );
      if (response?.success) {
        generalState?.setLoading(true);
        setIsManually(false);
        setCurrentPage("preview-data");
        navigate("/influencer/dashboard/?preview-data=true");
      }
    } catch (error) {
      toast({
        variant: "destructive",
        title: "There was a problem with your request.",
        description: "Please Retry",
      });
    }
  };
  const handleSubmitContentForm = async () => {
    try {
      const response = await influencerState?.updateContentInfo(contentData);
      if (response?.success) {
        setCurrentPage("audience");
        // navigate("/influencer/build_profile?page=3");
      }
    } catch (error) {
      toast({
        variant: "destructive",
        title: "There was a problem with your request.",
        description: "Please Retry",
      });
    }
  };
  //  real time chips changes ------------------
  const GoThroughArray = (arr: any[] | [], stringName: string) => {
    let chips: number = 0;

    if (arr.length > 0) {
      if (typeof arr[0] === "object") {
        // means the elements e=inside the array are objects ------------

        for (let index = 0; index < arr.length; index++) {
          const element = arr[index];
          const credits = GoThroughObjects(element, stringName);
          chips += credits;
        }
      } else {
        if (arr.filter((e: any) => e && e.length > 0)?.length > 0) {
          if (chipsData[stringName]) {
            chips += chipsData[stringName];
          }
        }
      }
    }
    return chips;
  };
  const GoThroughObjects = (obj: object, stringName: string) => {
    let chips: number = 0;

    const keysArr = Object.keys(obj || {});
    const ValuesArr = Object.values(obj || {});

    for (let index = 0; index < ValuesArr.length; index++) {
      const element = ValuesArr[index];

      // is an array ---------------
      if (Array.isArray(element)) {
        // console.log(keysArr[index])
        const credits = GoThroughArray(
          element,
          stringName + "." + keysArr[index]
        );
        chips += credits;
      }

      // is an object ----------------
      else if (typeof element === "object") {
        const credits = GoThroughObjects(
          element,
          stringName + "." + keysArr[index]
        );
        chips += credits;
      }

      // is a string ------------------
      else {
        // find the value and add in the chips
        if (element !== null && element !== "") {
          if (chipsData[stringName + "." + keysArr[index]]) {
            chips += chipsData[stringName + "." + keysArr[index]];
          }

          //  followers edge cases
          else if (
            (stringName + "." + keysArr[index]).includes("personal.followers")
          ) {
            chips += chipsData["social.followers"];
          }

          //  social links edge cases
          else if (
            [
              "personal.linkedinLink",
              "personal.twitterLink",
              "personal.instaLink",
              "personal.fbLink",
              "personal.telegramLink",
              "personal.whatsappLink",
              "personal.YouTubeLink",
              "personal.linkTreeLink",
            ].includes(stringName + "." + keysArr[index])
          ) {
            chips += chipsData["social.link"];
          }
        }
      }
    }

    return chips;
  };
  function CountTheChips(data: object | [], stringName: string) {
    let credits: number = 0;

    // check is the data is objet or array
    if (Array.isArray(data)) {
      credits = GoThroughArray(data, stringName);
    }

    // is an object -------------
    else {
      credits = GoThroughObjects(data, stringName);
    }

    return credits;
  }

  return {
    currentSection,
    setCurrentSection,
    currentPage,
    isManually,
    setIsManually,
    setCurrentPage,
    setErrorArray,
    referCode,
    setReferCode,
    profileFormImages,
    setProfileFormImages,
    profileData,
    setProfileData,
    chipsData,
    setChipsData,
    contentData,
    setContentData,
    collabData,
    setCollabData,
    monetizationData,
    setMonetizationData,
    audienceData,
    setAudienceData,
    chargesData,
    setChargesData,
    verificationData,
    setVerficationData,
    MediaKitsheetsData,
    setMediaKitSheetsData,
    handleSubmit,
    fade,
  };
};
